import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_role as ENUM } from '../../_invocations/_base/ENUM__invocation_role';
import { INVOCATION_GRID2D__view } from '../../_invocations/grid2d/INVOCATION_GRID2D__view';
import { INVOCATION_IMAGE__viewport } from '../../_invocations/image/INVOCATION_IMAGE__viewport';
import { INVOCATION_VISION_ML__rembg } from '../../_invocations/vision/INVOCATION_VISION_ML__rembg';
import { ENUM__graph_template_name } from '../sd_1/ENUM__graph_template_name';

export function GENERATION_TOOL__image_edit__rembg() {
  let out = new DTO__generation_tool();
  out.name = ENUM__graph_template_name.REMOVE_BACKGROUND;

  /*
   *
   */

  const graph = DTO_GRAPH__instance.CREATE_NEW();
  out.graph = graph;

  /*
   *
   */

  const node__grid2d = INVOCATION_GRID2D__view.create_node_for(graph);

  /*
   *
   */
  let node__rembg = INVOCATION_VISION_ML__rembg.create_node_for(graph, ENUM.VISION__REMBG);
  graph.edge__try_add_for_fields(node__rembg.out__image, node__grid2d.image);

  /*
   *
   */
  const node__viewport = INVOCATION_IMAGE__viewport.create_node_for(graph);
  graph.edge__try_add_for_fields(node__viewport.out__image_cropped, node__rembg.image);

  /*
   * VIEW
   */
  let fields__visible: FIELD__base[] = [node__viewport.image, node__rembg.model_type, node__rembg.alpha_matting];
  let field_column_id = node__rembg.model_type.meta.field_id;
  let field_row_id = node__rembg.alpha_matting.meta.field_id;

  out.view__add({
    //
    fields__visible,
    fields__stored: fields__visible,
    //
    field_column_id,
    field_row_id,
  });

  /*
   *
   */

  return out;
}
